<template>
  <el-step
      ref="gjStep"
      v-bind="$attrs"
      v-on="$listeners"
  ></el-step>
</template>

<script>
  export default {
    name: "gj-step"
  }
</script>

<style scoped>

</style>
